import { Modal } from '~/components/modals/CurieModal'

interface LoadingModalProps {
  isOpen: boolean
  message?: string
}

export function LoadingModal({ isOpen, message = 'Loading...' }: LoadingModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={() => {}} className='w-[400px]'>
      <div className='flex flex-col items-center justify-center py-12 px-6 select-none'>
        <div className='w-12 h-12 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin mb-6' />
        <div className='text-center'>
          <p className='text-lg font-medium text-gray-900'>{message}</p>
        </div>
      </div>
    </Modal>
  )
}
